import React, { useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import theme from "src/theme";
import {
  Grid,
  Typography,
  Button,
  CircularProgress,
  Link,
  Select,
  MenuItem,
  Box,
  InputLabel,
  makeStyles,
} from "@material-ui/core";
import { useNavigate } from "react-router-dom";
import { ValidatorForm, TextValidator } from "react-material-ui-form-validator";
import logo from "src/assets/images/conexoplus.png";

import { autenticarUsuario } from "src/store/actions/usuario";
import * as types from "src/store/types/usuario";

const useStyles = makeStyles((theme) => ({
  container: {
    display: "grid",
    gridTemplateAreas: "'logo form'",
    gridTemplateRows: "100vh",
    gridTemplateColumns: "1fr 1fr",
    [theme.breakpoints.down("sm")]: {
      gridTemplateAreas: "'logo''form'",
      gridTemplateColumns: "1fr",
      gridTemplateRows: "30vh 50vh",
    },
  },
  logo: {
    gridArea: "logo",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      alignItems: "flex-end",
    },
  },
  form: {
    gridArea: "form",
    display: "flex",
    alignItems: "center",
    [theme.breakpoints.down("sm")]: {
      justifyContent: "center",
    },
  },
}));

function Login() {
  const classes = useStyles();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, select_empresa, empresas, usuario } = useSelector(
    (state) => state.usuario
  );
  const [data, setData] = useState({ email: "", password: "" });
  const [empresaId, setEmpresaId] = useState("");

  useEffect(() => {
    if (!empresas.length) return;

    setEmpresaId(empresas[0].id);
  }, [empresas]);

  async function handleSignIn() {
    try {
      dispatch({ type: types.USUARIO_LOADING, payload: true });
      await autenticarUsuario(data.email, data.password, navigate, empresaId);
      dispatch({ type: types.USUARIO_LOADING, payload: false });
    } catch (error) {
      dispatch({ type: types.USUARIO_LOADING, payload: false });
    }
  }

  function closeSelectEmpresa() {
    dispatch({ type: types.USUARIO_SET_SELECT_EMPRESA, payload: false });
    setEmpresaId("");
  }

  return (
    <Box className={classes.container}>
      <Box className={classes.logo}>
        <img
          src={logo}
          alt="Logomarca Conexo Mais"
          style={{ width: 280, height: 120 }}
        />
      </Box>
      <Box className={classes.form}>
        {select_empresa ? (
          <Box display="flex" flexDirection="column" gap="8px">
            <Typography variant="h2">
              Seja bem-vindo(a) {usuario.nome}
            </Typography>
            <InputLabel style={{ marginTop: "8px" }}>
              Selecione uma empresa
            </InputLabel>
            <Select
              value={empresaId}
              onChange={(e) => setEmpresaId(e.target.value)}
              variant="outlined"
            >
              {empresas.map((empresa) => (
                <MenuItem key={empresa.id} value={empresa.id}>
                  {empresa.nome}
                </MenuItem>
              ))}
            </Select>
            <Box display="flex" justifyContent="flex-end">
              <Button onClick={closeSelectEmpresa}>Cancelar</Button>
              <Button onClick={handleSignIn}>Confirmar</Button>
            </Box>
          </Box>
        ) : (
          <ValidatorForm
            onSubmit={handleSignIn}
            onError={(errors) => console.log(errors)}
            style={{ width: "clamp(300px, 100%, 500px)" }}
          >
            <Typography variant="h2">Entrar</Typography>
            <Grid container spacing={2} style={{ marginTop: 20 }}>
              <Grid item sm={12}>
                <TextValidator
                  fullWidth
                  label="E-Mail"
                  name="E-Mail"
                  onChange={(event) =>
                    setData({
                      ...data,
                      email: event.target.value,
                    })
                  }
                  type="text"
                  value={data.email}
                  variant="outlined"
                  validators={["required", "isEmail"]}
                  errorMessages={[
                    "este campo é obrigatório",
                    "não é um e-mail válido",
                  ]}
                />
              </Grid>
              <Grid item sm={12}>
                <TextValidator
                  fullWidth
                  label="Senha"
                  name="senha"
                  onChange={(event) =>
                    setData({
                      ...data,
                      password: event.target.value,
                    })
                  }
                  onKeyPress={(e) =>
                    e.key === "Enter" ? handleSignIn() : null
                  }
                  type="password"
                  validators={["required"]}
                  errorMessages={["este campo é obrigatório"]}
                  value={data.password}
                  variant="outlined"
                />
              </Grid>
            </Grid>
            {loading ? (
              <CircularProgress
                style={{
                  display: "block",
                  width: 45,
                  height: 45,
                  marginTop: 25,
                  marginLeft: "auto",
                  marginRight: "auto",
                }}
              />
            ) : (
              <div>
                <Button
                  type="submit"
                  style={{
                    marginTop: 25,
                    width: "100%",
                    "&:hover": {
                      backgroundColor: theme.palette.common.rozaPtz,
                    },
                  }}
                  color="primary"
                  size="large"
                  variant="contained"
                >
                  Entrar
                </Button>
              </div>
            )}
            <Typography
              variant="body1"
              style={{
                marginTop: 10,
                color: theme.palette.text.secondary,
              }}
            >
              <Link
                href="/recuperar-senha"
                style={{
                  "&:hover": {
                    cursor: "pointer",
                    color: "#000 !important",
                  },
                }}
              >
                Esqueci minha senha?
              </Link>
            </Typography>
          </ValidatorForm>
        )}
      </Box>
    </Box>
  );
}

export default Login;
